import styled from 'styled-components';
import { scarpaGray500, white } from '@habitech/shared';

export const SearchBarRetentionContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 8px 0 0px 0;
    padding: 0 24px;
    background-color: ${white};
    border-radius: 4px;
    width: 100%;
    max-width: 320px;
    gap: 8px;

    label {
        color: ${scarpaGray500};
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: auto;
        padding: 0 8px;
        margin: 8px 0 16px 0;
        align-items: center;
        width: 100%;
        max-width: 100%;

        button {
            max-width: 160px;
        }

        .container-search {
            width: 420px;
            margin-right: 16px;
        }
    }
`;
